import http from './httpService';
import * as utils from './utils';
/*global API */

const registerEndpoint = `${API}/api/Auth/Register`;
const loginEndpoint = `${API}/api/Auth/Login`;
const refreshTokenEndpoint = `${API}/api/Auth/RefreshToken`;
const forgotPasswordEndpoint = `${API}/api/Auth/ForgotPassword`;
const changePasswordEndpoint = `${API}/api/Auth/ChangePassword`;
const resetPasswordEndpoint = `${API}/api/Auth/resetPasswordApp`;
const userEndpoint = `${API}/api/Users`;

export function register(UserForRegisterDto) {
  return http.post(registerEndpoint, UserForRegisterDto);
}

export function login(user) {
  return http.post(loginEndpoint, user);
}

export function refreshToken(tokenData) {
  return http.post(refreshTokenEndpoint, tokenData);
}

export function forgotPassword(emailAddress) {
  /*global JOB_PORTAL_URL */
  const jobPortalEndpoint = `${JOB_PORTAL_URL}`;
  return http.get(forgotPasswordEndpoint, { params: { emailAddress: emailAddress, host: jobPortalEndpoint } });
}

export function changePassword(user) {
  let userTmp = utils.getUserFromToken();
  let userForBackend = { ...user, userName: userTmp.unique_name };
  return http.post(changePasswordEndpoint, userForBackend);
}

export function resetPassword(code, email, password1, password2) {
  return http.get(resetPasswordEndpoint, { params: { email, code, password1, password2 } });
}

export function getJwt() {
  return localStorage.getItem('token');
}

export function getRefreshJwt() {
  return localStorage.getItem('refreshToken');
}

export function loginWithJwt(jwt) {
  localStorage.setItem('token', jwt);
}

export function getUser() {
  let userTmp = utils.getUserFromToken();
  return http.get(userEndpoint + `/${userTmp.nameid}`);
}

// Admin can select any other user to edit it
export function getUserForAdmin(id) {
  return http.get(userEndpoint + `/admin/${id}`);
}

export function getCompanyForAdmin(id) {
  return http.get(userEndpoint + `/admin/company/${id}`);
}

export function getUsers() {
  return http.get(userEndpoint);
}

export function updateUser(userForUpdate) {
  let userTmp = utils.getUserFromToken();

  const formData = new FormData();

  formData.append('firstName', userForUpdate.firstName);
  formData.append('lastName', userForUpdate.lastName);
  formData.append('email', userForUpdate.email);

  // In case user is changing the Photo, it must be in 'blob' form. Otherwise we already have it saved and it's just a url string
  if (userForUpdate.userProfilePhoto?.file) {
    formData.append('newPhoto', userForUpdate.userProfilePhoto.file);
  } else {
    // if sent oldPhotoUrl is null, the backend will delete it
    formData.append('oldPhotoUrl', userForUpdate.userProfilePhoto);
  }

  return http.put(userEndpoint + `/${userTmp.nameid}`, formData);
}

// Admin can update any user's settings
export function updateUserAsAdmin(userForUpdate, userFromDbToEdit) {
  return http.put(userEndpoint + `/updateUser/admin/${userFromDbToEdit.id}`, {
    firstName: userForUpdate.firstName,
    lastName: userForUpdate.lastName,
    email: userForUpdate.email,
  });
}

// settings must be defined for backend as settings = [{id: x, name?: y, value: z}, ...]
export function updateUserSettings(settings) {
  let userTmp = utils.getUserFromToken();
  return http.put(userEndpoint + `/settings/${userTmp.nameid}`, settings);
}

export function updateUserFromList(userForUpdate) {
  let userTmp = utils.getUserFromToken();

  return http.put(userEndpoint + '/user', {
    userToChangeId: userForUpdate.id,
    ownerId: userTmp.nameid,
    firstName: userForUpdate.firstName,
    lastName: userForUpdate.lastName,
    email: userTmp.email,
    userRole: userForUpdate.userRole?.value,
  });
}

export function createUser(userForCreation) {
  let userTmp = utils.getUserFromToken();
  return http.post(userEndpoint + `/${userTmp.nameid}`, { ...userForCreation, role: userForCreation.userRole?.value });
}

export function addOrUpdateCompany(company) {
  let userTmp = utils.getUserFromToken();
  company.userId = userTmp.nameid;

  const formData = new FormData();

  formData.append('address.city', company.cityControllerSelect.label);
  formData.append('address.countryCode', company.countryControllerSelect.value);
  formData.append('address.googlePlaceId', company.location.googlePlaceId);
  formData.append('address.lat', company.location.lat);
  formData.append('address.latForStreetSearch', 0);
  formData.append('address.lng', company.location.lng);
  formData.append('address.lngForStreetSearch', 0);
  formData.append('address.street', company.location.street.label);

  formData.append('name', company.name);
  company.website && formData.append('website', company.website);
  company.facebookUrl && formData.append('facebookUrl', company.facebookUrl);
  company.twitterHandle && formData.append('twitterHandle', company.twitterHandle);
  company.linkedInUrl && formData.append('linkedInUrl', company.linkedInUrl);
  company.instagramUrl && formData.append('instagramUrl', company.instagramUrl);
  company.linkToVideo && formData.append('linkToVideo', company.linkToVideo);
  formData.append('description', company.description);
  formData.append('userId', userTmp.nameid);
  formData.append('id', company.id);
  formData.append('LogoPhotoUrl', company.logoPhotoUrl);

  if (company.imgCompanyLogo === undefined) {
    formData.append('deleteCompanyLogo', false);
  } else if (company.imgCompanyLogo === null) {
    formData.append('deleteCompanyLogo', true);
  } else {
    formData.append('companyLogo', company.imgCompanyLogo.file);
  }

  return http.post(userEndpoint + '/company', formData);
}

export function addOrUpdateCompanyAsAdmin(company, companyDescription) {
  company.description = companyDescription;

  return http.post(userEndpoint + '/company/admin', company);
}

export function getCompany() {
  let userTmp = utils.getUserFromToken();
  return http.get(userEndpoint + `/company/${userTmp?.nameid}`);
}

export function setUserStatus(idTmp, newStatus) {
  let userTmp = utils.getUserFromToken();
  return http.put(userEndpoint + '/setUserStatus', {
    userChangingStatusId: userTmp.nameid,
    id: idTmp,
    status: newStatus,
  });
}
